/*
Styles
 */
import "./ProgressBar.scss";

const ProgressBar = ({ step }) => {
  const steps = [1, 2, 3, 4, 5];
  return (
    <div className="progress__wrap">
      <span className="counter">{step !== 6 ? `${step} / 5` : "Results"}</span>
      {step >= 2 && step < 6 && (
        <div className="dots">
          {steps.map((item, index) => (
            <span key={index} className={step >= item ? "active" : ""}></span>
          ))}
        </div>
      )}
    </div>
  );
};
export default ProgressBar;
